import AppConfig from '../config/AppConfig';
import { getCookie } from './functions';

const siDocsBannerDisabledByUserCookie = getCookie('si_documentation_banner_disabled_by_user');
const siDocsBannerTimestampCookie = getCookie('si_documentation_banner_timestamp');
const deltaInSeconds = Date.now() / 1000 - parseInt(siDocsBannerTimestampCookie, 10);
const maxTimeToDisplayInSeconds = 60 * 60 * 24 * parseInt(AppConfig.MAX_DAYS_TO_DISPLAY_SI_DOCS_BANNER, 10);

export const siDocsBannerNotExpired = deltaInSeconds < maxTimeToDisplayInSeconds;
export const siDocsBannerDisabledByUser = siDocsBannerDisabledByUserCookie?.toLowerCase() === 'true';
